<template>
  <div class="mb-20">
    <!-- Did not join Affiliate Program -->
    <div v-if="!joinedAffiliation" class="flex flex-col items-center">
      <div class="my-8 text-center px-4 lg:px-0">
        <!-- This is to avoid breaking Adore Me into Adore \n Me on mobile but keep it on the same line on desktop -->
        <span class="text-4xl font-semibold font-montserrat"
          >Start earning with
          <span class="hidden lg:inline">Adore Me</span>
          <span class="inline lg:hidden"><br />Adore Me</span>
        </span>
      </div>
      <div class="flex flex-col lg:flex-row items-start lg:w-3/4 mb-8 lg:justify-between">
        <div class="lg:w-1/3 p-4 flex flex-col lg:items-center mt-8 lg:mt-0">
          <div class="flex items-center mt-4 mb-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="text-primary h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
              />
            </svg>
            <span class="ml-2 text-2xl lg:text-3xl font-medium font-montserrat">Join as an Affiliate</span>
          </div>
          <p class="leading-normal lg:text-center lg:text-2xl">
            It’s free to get started. Access marketing materials, tools and more!
          </p>
        </div>
        <div class="lg:w-1/3 p-4 flex flex-col lg:items-center mt-8 lg:mt-0">
          <div class="flex items-center mt-4 mb-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="text-primary h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
              />
            </svg>
            <p class="ml-2 text-2xl lg:text-3xl font-medium font-montserrat">Promote Adore Me</p>
          </div>
          <p class="leading-normal lg:text-center lg:text-2xl">
            Share Adore Me with your target audience. There’s a match for every need.
          </p>
        </div>
        <div class="lg:w-1/3 p-4 flex flex-col lg:items-center mt-8 lg:mt-0">
          <div class="flex items-center mt-4 mb-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="text-primary h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <h1 class="ml-2 text-2xl lg:text-3xl font-medium font-montserrat">Start earning</h1>
          </div>
          <p class="leading-normal lg:text-center lg:text-2xl">
            You can receive up to $50 for every new customer. Check out the
            <a href="/how-it-works" target="blank" @click="faqGAEvent">FAQ</a>
            for more details.
          </p>
        </div>
      </div>
      <!-- Join Section -->
      <div v-if="creator" class="w-full space-y-6 p-4 mt-8 lg:mt-16 lg:p-0 lg:w-1/3">
        <div class="space-y-4">
          <div class="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="text-gray-700 h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
            <label class="ml-2 normal-case text-xl" for="paypal_address">PayPal Address</label>
          </div>
          <input
            v-model="paypalAddress"
            class="border-2 border-gray-700 rounded"
            name="paypal_address"
            type="text"
            placeholder="Fill in your PayPal address here"
          />
          <p class="text-md">
            This is the PayPal address you will cashout money to. If you change it here, it will become your primary
            address.
          </p>
        </div>
        <div class="flex items-center">
          <input id="agreed_to_terms" v-model="agreedToTerms" type="checkbox" class="form-checkbox h-6 w-6" />
          <label class="ml-3 text-black normal-case text-lg lg:text-xl" for="agreed_to_terms">
            I agree with the
            <span class="underline ml-1 font-bold cursor-pointer" @click="showTermsModal">collaboration terms</span>.
          </label>
        </div>
        <div class="flex justify-center">
          <button
            id="join-affiliation"
            v-promise-btn
            name="join-affiliation"
            class="button button-primary button-lg w-full lg:text-xl lg:h-12"
            :class="{ 'btn-disabled cursor-not-allowed opacity-50': !agreedToTerms || isLoading || !paypalAddress }"
            :disabled="!agreedToTerms || isLoading || !paypalAddress"
            @click="joinAffiliation"
          >
            Join Now
          </button>
        </div>
      </div>
      <div v-if="!creator" class="w-full space-y-6 p-4 mt-8 lg:mt-16 lg:p-0 lg:w-1/3">
        <div class="flex justify-center">
          <a class="block w-full lg:h-12" href="/login">
            <button
              id="join-affiliation"
              name="join-affiliation"
              class="button button-primary button-lg w-full lg:text-xl lg:h-12"
              @click="joinNowGAEvent"
            >
              Join Now
            </button>
          </a>
        </div>
      </div>
    </div>

    <!-- Joined Affiliate Program but no Coupon -->
    <div v-if="joinedAffiliation && !creator.affiliate.enabled" class="mt-10 lg:text-center text-xl m-8 lg:m-16">
      Thank you for joining the Affiliate Program. We will come back to you as soon as possible with the next steps so
      that you can start enjoying the benefits. In the meantime you can check our
      <a class="underline ml-1 font-bold" href="/news/affiliation-program" target="blank">commission plan</a>.
    </div>

    <!-- Joined Affiliate Program -->
    <div v-if="joinedAffiliation && creator.affiliate.enabled" class="flex justify-center lg:flex-row flex-col p-4">
      <div class="flex flex-col lg:mr-8 lg:w-3/5">
        <div class="lg:mr-8 flex flex-col">
          <div class="grid grid-cols-10 gap-2 lg:gap-4 items-stretch">
            <template v-for="(insight, index) in insights">
              <dashboard-counter class="lg:col-span-2 col-span-5" :counter="insight" :key="index"></dashboard-counter>
            </template>
          </div>
        </div>
        <!-- chart -->
        <div v-if="overtimeStats && overtimeStats.length !== 0 && !isLoadingChart" class="mt-5 space-y-5 flex-col">
          <div class="flex flex-col space-y-5 lg:flex-row lg:space-y-0 lg:justify-between">
            <div class="flex w-full overflow-x-scroll lg:block lg:w-auto lg:overflow-auto">
              <button
                v-for="(value, key) in chartTypes"
                :key="key"
                :value="key"
                class="button button-primary border-l-1 border-black outline-none focus:outline-none"
                :class="{ '!bg-primary-300': key === chartTypeFilter }"
                @click="updateChart(key)"
              >
                {{ value }}
              </button>
            </div>
            <div class="flex w-full overflow-x-scroll justify-end lg:block lg:w-auto lg:overflow-auto">
              <button
                v-for="(value, key) in chartPeriodTypes"
                :key="key"
                :value="key"
                class="button button-primary bg-white text-black border-l-1 border-black outline-none focus:outline-none hover:text-white"
                :class="{
                  '!bg-primary-300': value === chartPeriodTypeFilter,
                  'text-white': value === chartPeriodTypeFilter,
                }"
                @click="getOvertimeStats(key)"
              >
                {{ value }}
              </button>
            </div>
          </div>
          <AffiliateChart v-if="chartData" class="w-full" :chart-data="chartData" />
          <div v-if="overtimeStats && overtimeStats.length === 0" class="text-2xl font-montserrat mt-6 text-center">
            No traffic yet
            <p class="text-xl mt-1">
              Please make sure that your affiliate link is visible in your social media channels and posts.
            </p>
          </div>
        </div>
        <div v-if="isLoadingChart" class="flex items-center justify-center h-32">
          <LoadingSpinner class="h-10 w-10" />
        </div>
      </div>
      <div class="flex flex-col lg:w-2/5">
        <div>
          <div class="grid grid-cols-3 items-center">
            <label v-tooltip="utmLinkTooltip">Tracking link</label>
            <input
              v-model="utmLink"
              type="text"
              placeholder="https://c.adore.me/user"
              class="cursor-not-allowed col-span-2"
              readonly
              @click="
                debouncedCopyText(utmLink, 'Tracking link copied!');
                trackingLinkGAEvent();
              "
            />
            <label v-tooltip="couponCodeTooltip">Coupon Code</label>
            <input
              v-model="coupon"
              type="text"
              placeholder="Not available"
              class="cursor-not-allowed col-span-2"
              readonly
              @click="
                debouncedCopyText(coupon, 'Coupon code copied!');
                couponCodeGAEvent();
              "
            />
          </div>
          <p class="mt-4">
            Every <strong>new customer</strong> that shops on adoreme.com with your link and code will get their
            <strong>first VIP set</strong> for just <strong>$19.99</strong>.
          </p>
        </div>

        <!-- payments section -->
        <div v-if="!isLoadingBalance" class="grid grid-cols-2 gap-4 my-8">
          <div class="font-bold text-2xl col-span-2 mb-2">Balance Details</div>
          <div class="font-semibold">
            <span v-tooltip="totalBalanceTooltip" class="flex">
              <affiliate-info-icon class="mr-2" />
              Total
            </span>
          </div>
          <div>${{ totalBalance }}</div>
          <div class="font-semibold">
            <span v-tooltip="pendingBalanceTooltip" class="flex">
              <affiliate-info-icon class="mr-2" />
              Pending
            </span>
          </div>
          <div>${{ pendingBalance }}</div>
          <div class="font-bold text-xl mt-2">
            <span v-tooltip="clearedBalanceTooltip" class="flex items-center">
              <affiliate-info-icon class="mr-2" />
              Cleared
            </span>
          </div>
          <div class="font-bold text-xl mt-2">${{ clearedBalance }}</div>
          <div class="w-full col-span-2">
            <div v-if="!hasW9Submitted" class="flex p-2 my-6 flex-row gap-2 bg-warning-100">
              <img class="w-16 h-16" src="/assets/stamp.png" />
              <div class="flex flex-col">
                <p class="font-bold mb-1">Taxpayer Information</p>
                <p class="text-sm">
                  In order to participate in our affiliate programme, we require you to complete a standard W-9
                </p>
                <a class="font-semibold underline pt-2" target="_blank" :href="w9FormUrl">Fill out your W9 form here</a>
              </div>
            </div>
            <button
              id="cashout-affiliation"
              v-promise-btn
              class="button button-primary button-sm w-full"
              :class="{ 'btn-disabled cursor-not-allowed opacity-50': belowClearedLimit || isLoading }"
              :disabled="belowClearedLimit || !hasW9Submitted || isLoading"
              @click="processCashout"
            >
              Cashout
            </button>
          </div>
          <p class="mt-2 col-span-2">
            See your payments history in the <a href="/my-payments" @click="myPaymentsGAEvent">My Payments</a> section
          </p>
        </div>

        <div v-if="isLoadingBalance" class="flex items-center justify-center h-32">
          <LoadingSpinner class="h-10 w-10" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { Bus } from '../../bus';
import { terms } from './AffiliateTC';
import AffiliateInfoIcon from './AffiliateInfoIcon.vue';
import LoadingSpinner from '../LoadingSpinner.vue';
import debounce from 'lodash/debounce';
import { gtmEvent } from '../../services/gtm';

export default {
  name: 'AffiliateComponent',
  components: {
    AffiliateInfoIcon,
    LoadingSpinner,
  },
  props: ['user', 'totalStats', 'hasW9Submitted'],
  data() {
    return {
      w9FormUrl: '',
      jotFormIds: {
        prod: '230593613053350',
        stg: '230663082825355',
      },
      creator: this.user,
      debouncedCopyText: this.copyText,
      terms: '',
      pendingBalanceTooltip:
        'This is the amount you can cash out when 30 days will have passed since the order was placed.',
      clearedBalanceTooltip:
        'This is the amount you can cash out right now. The minimum amount is $100 and we take into consideration orders placed up to 30 days after the first link visit.',
      utmLinkTooltip:
        'Copy this code on your social media accounts and/or share it with your friends, so that we can link them with you and reward you for their orders on adoreme.com',
      couponCodeTooltip:
        'This will enable your followers & friends to buy the first set on adoreme.com for $19.99 - VIP Membership',
      isLoading: false,
      isLoadingChart: false,
      isLoadingBalance: false,
      clearedBalance: 0,
      pendingBalance: 0,
      overtimeStats: null,
      chartTypeFilter: 'traffic',
      chartPeriodTypeFilter: 'all',
      chartPeriodTypes: {
        seven_days: '7d',
        one_month: '1m',
        six_months: '6m',
        one_year: '1y',
        all: 'all',
      },
      chartTypes: {
        traffic: 'Traffic',
        orders: 'Orders',
        conversion: 'Conversion',
        total_earned: 'Total Earned',
      },
      chartData: {
        datasets: [
          {
            label: 'Loading...',
            backgroundColor: '#541247',
            data: [],
          },
        ],
      },
      agreedToTerms: this.user?.affiliate?.agreed_to_terms,
      utmLink: this.user?.affiliate?.short_url,
      coupon: this.user?.affiliate?.coupon_code,
      paypalAddress: this.user?.paypal_address,
      insights: {
        traffic: {
          name: 'Traffic',
          value: 0,
          prefix: '',
        },
        new_customers: {
          name: 'New Customers',
          value: 0,
          prefix: '',
        },
        recurrent_orders: {
          name: 'Recurrent Orders',
          value: 0,
          prefix: '',
        },
        conversions: {
          name: 'Conversion',
          value: parseFloat(0).toFixed(2) + '%',
          prefix: '',
        },
        total_earned: {
          name: 'Total Earned',
          value: 0,
          prefix: '$',
        },
      },
    };
  },
  computed: {
    totalBalance() {
      return this.clearedBalance + this.pendingBalance;
    },
    totalBalanceTooltip() {
      return `This is the total $ amount you have available right now, out of which $${this.clearedBalance} ready to cash out.`;
    },
    belowClearedLimit() {
      return this.clearedBalance < 100;
    },
    joinedAffiliation() {
      return this.creator && this.creator.affiliate;
    },
  },
  async mounted() {
    let liveChatHubSpotScript = document.createElement('script');
    liveChatHubSpotScript.setAttribute('src', '//js-na1.hs-scripts.com/21150290.js');
    document.head.appendChild(liveChatHubSpotScript);

    if (!this.joinedAffiliation) return;

    this.w9FormUrl = `https://form.jotform.com/${
      window.location.hostname === 'creators.adoreme.com' ? this.jotFormIds.prod : this.jotFormIds.stg
    }?email=${this.creator.email}&userId=${this.creator.id}&campaign_permalink=affiliation`;

    this.updateInsights(this.totalStats);

    this.getBalanceDetails();

    this.getOvertimeStats(this.chartPeriodTypeFilter);
  },
  created() {
    this.debouncedCopyText = debounce(this.copyText, 300, {
      leading: true,
      trailing: false,
    });
  },
  methods: {
    trackingLinkGAEvent() {
      gtmEvent('tracking_link', {
        ga_category: 'affiliation',
        ga_action: 'tracking_link',
        ga_label: 'click_on_tracking_link',
      });
    },
    couponCodeGAEvent() {
      gtmEvent('coupon_code', {
        ga_category: 'affiliation',
        ga_action: 'coupon_code',
        ga_label: 'click_on_coupon_code',
      });
    },
    myPaymentsGAEvent() {
      gtmEvent('my_payments', {
        ga_category: 'affiliation',
        ga_action: 'my_payments',
        ga_label: 'click_on_my_payments',
      });
    },
    joinNowGAEvent() {
      gtmEvent('join_now', {
        ga_category: 'affiliation',
        ga_action: 'join_now',
        ga_label: 'click_on_join_now',
      });
    },
    showTermsModal() {
      this.terms = terms.replace(/\s/g, '&nbsp;').replace('\n', '<br>');

      Swal.fire({
        title: '<div class="text-lg">Agree with the terms and conditions</div>',
        html: `<div class='font-montserrat text-black overflow-y-auto text-xs h-64 text-left'>${this.terms}.</div>`,
        showClass: {
          popup: 'swal2-noanimation',
          backdrop: 'swal2-noanimation',
        },
      });
    },
    async joinAffiliation() {
      try {
        this.isLoading = true;

        const {
          data: { agree, creator, total_stats },
        } = await window.axios.post(`/affiliation/join`, {
          agree: true,
          paypal_address: this.paypalAddress,
        });

        this.agreeToTerms = agree;
        this.creator = { ...creator };

        this.agreedToTerms = this.creator.affiliate.agreed_to_terms;
        this.utmLink = this.creator.affiliate.short_url;
        this.coupon = this.creator.affiliate.coupon_code;
        this.paypalAddress = this.creator.paypal_address;

        this.updateInsights(total_stats);

        await this.getBalanceDetails();

        await this.getOvertimeStats(this.chartPeriodTypeFilter);

        // Hack to update button and link
        if (creator.affiliate.enabled) {
          document.querySelector('#affiliation-header-link').href = '/affiliation#cashout-affiliation';
          document.querySelector('#affiliation-header-button').textContent = 'Cashout Now';
        } else if (!creator.affiliate.enabled) {
          document.querySelector('#affiliation-header-button').style.visibility = 'hidden';
        }

        // Scroll to top of page
        window.scrollTo(0, 0);

        this.isLoading = false;
      } catch (e) {
        console.error(e);

        this.isLoading = false;
      }

      this.joinNowGAEvent();
    },
    async getOvertimeStats(type) {
      try {
        this.isLoadingChart = true;

        this.chartPeriodTypeFilter = this.chartPeriodTypes[type];

        const { data } = await window.axios.get(`/affiliation/overtime_stats?period=${this.chartPeriodTypeFilter}`);

        this.overtimeStats = data;

        this.updateChart(this.chartTypeFilter);

        this.isLoadingChart = false;
      } catch ($e) {
        console.error($e);

        this.isLoadingChart = false;
      }
    },
    async getBalanceDetails() {
      try {
        this.isLoadingBalance = true;

        const {
          data: { cleared_balance, pending_balance },
        } = await window.axios.get(`/affiliation/${this.creator.affiliate.id}/balance_details`);

        this.clearedBalance = cleared_balance;
        this.pendingBalance = pending_balance;

        this.isLoadingBalance = false;
      } catch ($e) {
        console.error($e);

        this.isLoadingBalance = false;
      }
    },
    async startPayment() {
      try {
        this.isLoading = true;

        const {
          data: { success },
        } = await window.axios.post(`/affiliation/${this.creator.affiliate.id}/cashout`);

        if (success) {
          this.clearedBalance = 0;
        }

        this.isLoading = false;
      } catch ($e) {
        console.error($e);

        this.isLoading = false;
      }
    },
    updateInsights(totalStats) {
      this.insights = {
        traffic: {
          name: 'Traffic',
          value: totalStats.traffic,
          prefix: '',
        },
        new_customers: {
          name: 'New Customers',
          value: totalStats.new_customers,
          prefix: '',
        },
        recurrent_orders: {
          name: 'Recurrent Orders',
          value: totalStats.recurrent_orders,
          prefix: '',
        },
        conversions: {
          name: 'Conversion',
          value: parseFloat(totalStats.conversion * 100).toFixed(2) + '%',
          prefix: '',
        },
        total_earned: {
          name: 'Total Earned',
          value: totalStats.total_earned,
          prefix: '$',
        },
      };
    },
    updateChart(type) {
      this.chartTypeFilter = type;

      if (this.chartTypeFilter === 'orders') {
        this.chartData = {
          datasets: [
            {
              label: 'New Customers',
              backgroundColor: '#541247',
              borderColor: '#541247',
              fill: false,
              tension: 0.4,
              data: this.overtimeStats.map((row) => {
                return {
                  x: row.label,
                  y: row['new_customers'],
                };
              }),
            },
            {
              label: 'Recurrent Orders',
              backgroundColor: '#2596be',
              borderColor: '#2596be',
              fill: false,
              tension: 0.4,
              data: this.overtimeStats.map((row) => {
                return {
                  x: row.label,
                  y: row['recurrent_orders'],
                };
              }),
            },
          ],
        };
      } else {
        this.chartData = {
          datasets: [
            {
              label: this.chartTypes[this.chartTypeFilter],
              backgroundColor: '#541247',
              borderColor: '#541247',
              fill: false,
              tension: 0.4,
              data: this.overtimeStats.map((row) => {
                return {
                  x: row.label,
                  y: row[this.chartTypeFilter],
                };
              }),
            },
          ],
        };
      }
    },
    copyText(value, toastText) {
      navigator.clipboard.writeText(value);
      Bus.$emit('alert', toastText);
    },
    async acceptTerms() {
      try {
        this.isLoading = true;

        const {
          data: { agree },
        } = await window.axios.patch(`/affiliation/${this.creator.affiliate.id}/accept_terms`, {
          agree: true,
        });

        this.agreeToTerms = agree;

        this.isLoading = false;
      } catch ($e) {
        console.error($e);

        this.isLoading = false;
      }
    },
    async processCashout() {
      if (!this.creator.paypal_address) {
        // No paypal address set
        const res = await Swal.fire({
          title: '<div class="text-lg">We\'re so happy that you want to join the Affiliate Program!✨</div>',
          html: "<div class='font-montserrat text-black'>Before that, there is only one more step that you need to complete.<br>You just need to go to your profile and complete your PayPal address.</div>",
          confirmButtonText: '<div class="text-sm">Edit my profile</div>',
          confirmButtonColor: '#813571',
          cancelButtonText: '<div class="text-sm">Cancel</div>',
          showCancelButton: false,
          showClass: {
            popup: 'swal2-noanimation',
            backdrop: 'swal2-noanimation',
          },
        });

        if (res.value) {
          window.location.href = '/profile/edit#payment';
        }

        return;
      }

      // only temporary
      if (!this.agreedToTerms) {
        this.terms = terms.replace(/\s/g, '&nbsp;').replace('\n', '<br>');
        const res = await Swal.fire({
          title: '<div class="text-lg">Agree with the terms and conditions</div>',
          html: `<div class='font-montserrat text-black overflow-y-auto text-xs h-64 text-left'>${this.terms}.</div>`,
          confirmButtonText: 'Ok',
          confirmButtonColor: '#813571',
          cancelButtonText: '<div class="text-sm">Cancel</div>',
          showCancelButton: true,
          showClass: {
            popup: 'swal2-noanimation',
            backdrop: 'swal2-noanimation',
          },
        });

        gtmEvent('terms', {
          ga_category: 'affiliation',
          ga_action: 'terms',
          ga_label: res.value ? 'yes' : 'no',
        });

        if (!res.value) {
          return;
        }

        await this.acceptTerms();
      }

      const res = await Swal.fire({
        title: '<div class="text-lg">Verify your PayPal address</div>',
        html: `<div class='font-montserrat text-black'>We will process this payment on this PayPal adress: <br> <strong>${this.creator.paypal_address}<strong> </div>`,
        confirmButtonText: '<div class="text-sm">Confirm</div>',
        confirmButtonColor: '#229173',
        cancelButtonColor: '#813571',
        cancelButtonText: '<div class="text-sm">Edit PayPal Address</div>',
        showCancelButton: true,
        showCloseButton: true,
        reverseButtons: true,
        showClass: {
          popup: 'swal2-noanimation',
          backdrop: 'swal2-noanimation',
        },
      });

      if (res.isConfirmed) {
        await this.startPayment();
      }

      if (res.dismiss === 'cancel') {
        window.location.href = '/profile/edit#payment';

        gtmEvent('edit_paypall_address', {
          ga_category: 'affiliation',
          ga_action: 'edit_paypall_address',
        });
      }

      gtmEvent('cashout', {
        ga_category: 'affiliation',
        ga_action: 'cashout',
        ga_label: 'click_on_cashout',
      });
    },
    faqGAEvent() {
      gtmEvent('FAQ', {
        ga_category: 'affiliation',
        ga_action: 'FAQ',
        ga_label: 'click_on_FAQ',
      });
    },
  },
};
</script>
